(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-collection"]) return;
  try {
    
  if (!customElements.get('tt-collection')) {
    customElements.define('tt-collection', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const panel = this.querySelector('[data-filter-panel]');
        const toggle = this.querySelector('[data-filter-toggle]');
        const sort = this.querySelector('[data-sort]');
        const media = window.matchMedia('(max-width: 749px)');
        const setExpanded = (expanded) => {
          if (!toggle || !panel) return;
          panel.hidden = !expanded;
          toggle.setAttribute('aria-expanded', String(expanded));
        };
        this.classList.add('is-enhanced');
        setExpanded(!media.matches);
        media.addEventListener('change', () => setExpanded(!media.matches), options);
        toggle?.addEventListener('click', () => setExpanded(panel.hidden), options);
        sort?.addEventListener('change', () => sort.form?.requestSubmit(), options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-footer"]) return;
  try {
    
  if (!customElements.get('tt-footer-localization')) {
    customElements.define('tt-footer-localization', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelectorAll('.tt-locale').forEach(details => {
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            this.querySelectorAll('.tt-locale[open]').forEach(other => {
              if (other !== details) other.open = false;
            });
          }, options);
          details.addEventListener('focusout', event => {
            if (!details.contains(event.relatedTarget)) details.open = false;
          }, options);
        });
        document.addEventListener('click', event => {
          this.querySelectorAll('.tt-locale[open]').forEach(details => {
            if (!details.contains(event.target)) details.open = false;
          });
        }, options);
        this.addEventListener('keydown', event => {
          const details = event.target.closest('.tt-locale');
          if (!details?.open) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            details.open = false;
            details.querySelector('summary').focus();
            return;
          }
          if (event.key === 'Enter' && event.target.matches('[data-country-search]')) event.preventDefault();
          if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          const buttons = Array.from(details.querySelectorAll('li:not([hidden]) button'));
          if (!buttons.length) return;
          event.preventDefault();
          const index = buttons.indexOf(document.activeElement);
          const next = event.key === 'ArrowDown' ? (index + 1) % buttons.length : (index < 0 ? buttons.length - 1 : (index - 1 + buttons.length) % buttons.length);
          buttons[next].focus();
        }, options);
        this.querySelectorAll('[data-country-search]').forEach(input => {
          input.addEventListener('input', () => {
            const normalize = value => value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase().trim();
            const query = normalize(input.value);
            const details = input.closest('.tt-locale');
            let count = 0;
            details.querySelectorAll('[data-country]').forEach(item => {
              item.hidden = !normalize(item.dataset.country).includes(query);
              if (!item.hidden) count++;
            });
            const status = details.querySelector('[data-country-count]');
            status.textContent = status.dataset.countryCount.replace('[count]', count);
          }, options);
        });
      }
      disconnectedCallback() { this.controller.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-header"]) return;
  try {
    
  if (!customElements.get('tt-header')) {
    customElements.define('tt-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.nav = this.querySelector('.tt-header__nav');
        this.indicator = this.querySelector('.tt-nav__indicator');
        this.dialog = this.querySelector('.tt-mobile-menu');
        this.toggle = this.querySelector('[data-menu-open]');
        this.nav.classList.add('is-enhanced');
        this.nav.querySelectorAll('[data-nav-item]').forEach(item => {
          item.addEventListener('pointerenter', () => this.moveIndicator(item), options);
        });
        this.nav.addEventListener('pointerleave', () => this.restoreIndicator(), options);
        this.nav.addEventListener('focusin', event => this.moveIndicator(event.target.closest('[data-nav-item]')), options);
        this.nav.addEventListener('focusout', event => {
          if (!this.nav.contains(event.relatedTarget)) this.restoreIndicator(false);
        }, options);
        this.querySelectorAll('.tt-locale, .tt-nav__item:is(details)').forEach(details => {
          details.addEventListener('toggle', () => {
            if (details.open && details.classList.contains('tt-locale')) {
              this.querySelectorAll('.tt-locale[open]').forEach(other => { if (other !== details) other.open = false; });
              this.nav.querySelectorAll('details[open]').forEach(other => { other.open = false; });
            }
            if (details.open && this.nav.contains(details)) {
              this.querySelectorAll('.tt-locale[open]').forEach(other => { other.open = false; });
              this.nav.querySelectorAll('details[open]').forEach(other => { if (other !== details) other.open = false; });
            }
            this.restoreIndicator();
          }, options);
          details.addEventListener('focusout', event => {
            if (!details.contains(event.relatedTarget) && !this.dialog.contains(details)) details.open = false;
          }, options);
        });
        this.toggle.addEventListener('click', () => {
          this.dialog.showModal();
          this.toggle.setAttribute('aria-expanded', 'true');
          document.body.classList.add('tt-menu-open');
        }, options);
        this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.toggle.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('tt-menu-open');
          this.dialog.querySelectorAll('.tt-locale[open]').forEach(details => { details.open = false; });
        }, options);
        document.addEventListener('click', event => {
          this.querySelectorAll('.tt-locale[open], .tt-header__nav details[open]').forEach(details => {
            if (!details.contains(event.target)) details.open = false;
          });
        }, options);
        this.addEventListener('keydown', event => {
          const locale = event.target.closest('.tt-locale');
          const details = locale || event.target.closest('.tt-header__nav details');
          if (event.key === 'Escape' && details?.open) {
            event.preventDefault();
            event.stopPropagation();
            details.open = false;
            details.querySelector('summary').focus();
          }
          if (event.key === 'Enter' && event.target.matches('[data-country-search]')) event.preventDefault();
          if (!locale?.open || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          const buttons = Array.from(locale.querySelectorAll('li:not([hidden]) button'));
          if (!buttons.length) return;
          event.preventDefault();
          const index = buttons.indexOf(document.activeElement);
          const next = event.key === 'ArrowDown' ? (index + 1) % buttons.length : (index < 0 ? buttons.length - 1 : (index - 1 + buttons.length) % buttons.length);
          buttons[next].focus();
        }, options);
        this.querySelectorAll('[data-country-search]').forEach(input => {
          input.addEventListener('input', () => {
            const query = input.value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase().trim();
            const locale = input.closest('.tt-locale');
            let count = 0;
            locale.querySelectorAll('[data-country]').forEach(item => {
              const name = item.dataset.country.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase();
              item.hidden = !name.includes(query);
              if (!item.hidden) count++;
            });
            const status = locale.querySelector('[data-country-count]');
            status.textContent = status.dataset.countryCount.replace('[count]', count);
          }, options);
        });
        this.desktop = window.matchMedia('(min-width: 1200px)');
        this.desktop.addEventListener('change', () => {
          if (this.dialog.open) this.dialog.close();
          this.querySelectorAll('.tt-locale[open], .tt-header__nav details[open]').forEach(details => { details.open = false; });
          this.restoreIndicator(false);
        }, options);
        this.observer = new ResizeObserver(() => this.moveIndicator(this.indicatorItem));
        this.observer.observe(this.nav);
        this.observer.observe(this);
        this.restoreIndicator();
      }
      moveIndicator(item) {
        this.indicatorItem = item;
        if (!item) { this.indicator.style.opacity = '0'; return; }
        const label = item.querySelector('.tt-nav__label');
        if (!label) { this.indicator.style.opacity = '0'; return; }
        const target = label.getBoundingClientRect();
        const nav = this.getBoundingClientRect();
        this.indicator.style.width = `${target.width}px`;
        this.indicator.style.transform = `translate(${target.left - nav.left}px, ${target.bottom - nav.top + 3}px)`;
        this.indicator.style.opacity = '1';
      }
      restoreIndicator(includeFocus = true) {
        const focused = includeFocus && this.nav.contains(document.activeElement) ? document.activeElement.closest('[data-nav-item]') : null;
        this.moveIndicator(focused || this.nav.querySelector('details[open]') || this.nav.querySelector('[data-nav-active]')?.closest('[data-nav-item]'));
      }
      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
        if (this.dialog.open) this.dialog.close();
        document.body.classList.remove('tt-menu-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-product-information"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-product-information')) {
    customElements.define('tt-product-information', class extends HTMLElement {
      connectedCallback() {
        this.desktop = matchMedia('(min-width: 990px)');
        this.panels = Array.from(this.querySelectorAll('[data-info-panel]'));
        this.tabs = Array.from(this.querySelectorAll('[data-info-tab]'));
        this.selection = { desktop: 'description', product: 'description', guide: 'notice' };
        this.onClick = (event) => {
          const tab = event.target.closest('[data-info-tab]');
          if (tab && this.contains(tab)) this.select(tab);
        };
        this.onKeyDown = (event) => {
          const tab = event.target.closest('[data-info-tab]');
          if (!tab || !this.contains(tab)) return;
          const list = tab.closest('[data-tab-list]');
          const tabs = Array.from(list.querySelectorAll('[data-info-tab]'));
          const index = tabs.indexOf(tab);
          const vertical = list.dataset.tabList === 'desktop';
          const steps = list.dataset.tabList === 'guide' ? 2 : 1;
          let next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === 'ArrowRight' && !vertical) next = index + 1;
          else if (event.key === 'ArrowLeft' && !vertical) next = index - 1;
          else if (event.key === 'ArrowDown' && (vertical || steps === 2)) next = index + steps;
          else if (event.key === 'ArrowUp' && (vertical || steps === 2)) next = index - steps;
          else return;
          event.preventDefault();
          const target = tabs[(next + tabs.length) % tabs.length];
          this.select(target);
          target.focus();
        };
        this.onResize = () => {
          const focused = this.contains(document.activeElement) ? document.activeElement.closest('[data-info-tab]') : null;
          this.update();
          if (focused) this.tabs.find((tab) => tab.dataset.infoTab === focused.dataset.infoTab && tab.getClientRects().length)?.focus();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeyDown);
        this.desktop.addEventListener('change', this.onResize);
        this.querySelectorAll('[data-tab-list]').forEach((list) => { list.hidden = false; });
        this.update();
        this.classList.add('is-enhanced');
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeyDown);
        this.desktop?.removeEventListener('change', this.onResize);
      }

      select(tab) {
        const key = tab.dataset.infoTab;
        const group = this.panels.find((panel) => panel.dataset.infoPanel === key).dataset.panelGroup;
        this.selection.desktop = key;
        this.selection[group] = key;
        this.update();
      }

      update() {
        const desktop = this.desktop.matches;
        this.tabs.forEach((tab) => {
          const scope = tab.closest('[data-tab-list]').dataset.tabList;
          const selected = tab.dataset.infoTab === this.selection[scope];
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const key = panel.dataset.infoPanel;
          panel.hidden = key !== this.selection[desktop ? 'desktop' : panel.dataset.panelGroup];
          panel.setAttribute('role', 'tabpanel');
          panel.tabIndex = 0;
          const tab = this.tabs.find((candidate) => candidate.dataset.infoTab === key && (candidate.closest('[data-tab-list]').dataset.tabList === 'desktop') === desktop);
          panel.setAttribute('aria-labelledby', tab.id);
        });
        this.querySelectorAll('[data-info-group]').forEach((group) => {
          group.hidden = desktop && !Array.from(group.querySelectorAll('[data-info-panel]')).some((panel) => !panel.hidden);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-product-tabs')) {
    customElements.define('tt-product-tabs', class extends HTMLElement {
      static editorTabs = new Map();

      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.editorMode = window.Shopify?.designMode === true;
        this.panelKeys = this.panels.map((panel) => {
          const attributes = panel.getAttribute('data-shopify-editor-block');
          return attributes ? JSON.parse(attributes).id : panel.id;
        });
        this.editorPanels = new Map();
        if (this.editorMode) {
          this.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
            const id = JSON.parse(element.getAttribute('data-shopify-editor-block')).id;
            this.editorPanels.set(id, element.closest('[data-panel]'));
          });
        }
        this.querySelector('[data-tab-list]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', (event) => { event.preventDefault(); this.select(index); }, { signal });
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
            this.tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }, { signal });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const panel = this.editorPanels.get(event.detail.blockId) || event.target.closest('[data-panel]');
          const index = this.panels.indexOf(panel);
          if (index >= 0) this.select(index);
        }, { signal });
        this.classList.add('tt-tabs-ready');
        const savedPanel = this.editorMode ? this.constructor.editorTabs.get(this.dataset.sectionId) : null;
        const savedIndex = this.panelKeys.indexOf(savedPanel);
        this.select(savedIndex >= 0 ? savedIndex : 0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
      select(index) {
        this.tabs.forEach((tab, current) => {
          tab.setAttribute('aria-selected', String(current === index));
          tab.tabIndex = current === index ? 0 : -1;
          this.panels[current].hidden = current !== index;
        });
        if (this.editorMode) {
          if (this.panels[index]) this.constructor.editorTabs.set(this.dataset.sectionId, this.panelKeys[index]);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-reviews')) {
    customElements.define('tt-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.rail = this.querySelector('[data-review-rail]');
        this.dialog = this.querySelector('dialog');
        this.catalog = this.querySelector('[data-catalog]');
        this.player = this.querySelector('[data-player]');
        this.embed = this.querySelector('[data-embed]');
        this.catalogHeading = this.querySelector('[data-catalog-heading]');
        this.playerTitle = this.querySelector('[data-player-title]');
        this.titleTranslations = {};
        try { this.titleTranslations = JSON.parse(this.querySelector('[data-video-title-translations]')?.textContent || '{}'); } catch { /* Keep native metadata if data is unavailable. */ }
        this.activeIndex = -1;
        this.records = Array.from(this.rail.querySelectorAll('[data-video-id]')).map(card => ({
          key: card.dataset.videoKey,
          id: card.dataset.videoId,
          url: card.dataset.videoUrl,
          model: card.dataset.videoModel,
          title: card.dataset.videoTitle,
          author: card.dataset.videoAuthor,
          card
        }));
        this.querySelector('[data-open-catalog]').disabled = this.records.length === 0;
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-open-catalog')) {
            this.showCatalog();
            this.openDialog(button);
            this.catalogHeading.focus();
          } else if (button.hasAttribute('data-video-key')) {
            const index = this.records.findIndex(record => record.key === button.dataset.videoKey);
            if (index < 0) return;
            this.catalogOrigin = this.catalog.contains(button) ? button : null;
            this.catalogScroll = this.catalog.scrollTop;
            this.play(index);
            this.openDialog(button);
            this.playerTitle.focus();
          } else if (button.hasAttribute('data-close')) {
            this.dialog.close();
          } else if (button.hasAttribute('data-back')) {
            this.showCatalog();
            this.catalog.scrollTop = this.catalogScroll || 0;
            (this.catalogOrigin || this.catalogHeading).focus({ preventScroll: true });
          } else if (button.hasAttribute('data-player-previous')) {
            this.play(this.activeIndex - 1);
          } else if (button.hasAttribute('data-player-next')) {
            this.play(this.activeIndex + 1);
          } else if (button.hasAttribute('data-rail-previous')) {
            this.scrollRail(-1);
          } else if (button.hasAttribute('data-rail-next')) {
            this.scrollRail(1);
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.embed.replaceChildren();
          this.unlockScroll();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        this.rail.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
        this.rail.addEventListener('focusin', event => this.revealCard(event.target.closest('.tt-reviews__item')), options);
        this.enableDragScroll(this.rail, 'x', options);
        this.enableDragScroll(this.catalog, 'y', options);
        this.addEventListener('shopify:block:select', event => this.revealCard(event.target.closest('.tt-reviews__item')), options);
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.rail);
        this.metadataObserver = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const record = this.records.find(item => item.key === entry.target.dataset.videoKey);
            if (record) this.loadMetadata(record);
            this.metadataObserver.unobserve(entry.target);
          }
        }, { rootMargin: '200px' });
        this.querySelectorAll('[data-video-key]').forEach(card => this.metadataObserver.observe(card));
        this.updateArrows();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.metadataObserver?.disconnect();
        this.embed?.replaceChildren();
        if (this.dialog?.open) this.dialog.close();
        this.unlockScroll();
      }

      updateArrows() {
        this.querySelector('[data-rail-previous]').disabled = this.rail.scrollLeft <= 2;
        this.querySelector('[data-rail-next]').disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      }

      enableDragScroll(surface, axis, options) {
        let drag = null;
        let suppressClick = false;
        surface.classList.add('tt-reviews__drag-scroll');
        const finish = () => {
          if (!drag) return;
          const { pointerId, captureTarget, moved } = drag;
          drag = null;
          suppressClick = moved;
          surface.classList.remove('is-dragging');
          if (captureTarget.hasPointerCapture(pointerId)) captureTarget.releasePointerCapture(pointerId);
        };
        surface.addEventListener('pointerdown', event => {
          suppressClick = false;
          // Touch keeps the browser's native swipe, momentum and page scrolling.
          if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary) return;
          const scrollable = axis === 'x' ? surface.scrollWidth > surface.clientWidth : surface.scrollHeight > surface.clientHeight;
          if (!scrollable) return;
          event.preventDefault();
          const captureTarget = event.target.closest('button') || surface;
          drag = {
            pointerId: event.pointerId,
            captureTarget,
            x: event.clientX,
            y: event.clientY,
            start: axis === 'x' ? surface.scrollLeft : surface.scrollTop,
            moved: false
          };
          captureTarget.setPointerCapture(event.pointerId);
        }, options);
        surface.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.pointerId) return;
          if (!(event.buttons & 1)) { finish(); return; }
          const dx = event.clientX - drag.x;
          const dy = event.clientY - drag.y;
          if (!drag.moved && Math.hypot(dx, dy) < 8) return;
          drag.moved = true;
          surface.classList.add('is-dragging');
          event.preventDefault();
          if (axis === 'x') surface.scrollLeft = drag.start - dx;
          else surface.scrollTop = drag.start - dy;
        }, options);
        for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) {
          surface.addEventListener(type, event => {
            if (event.pointerId === drag?.pointerId) finish();
          }, options);
        }
        surface.addEventListener('click', event => {
          if (!suppressClick || event.detail === 0) return;
          suppressClick = false;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { ...options, capture: true });
        surface.addEventListener('dragstart', event => event.preventDefault(), options);
        window.addEventListener('blur', finish, options);
        options.signal.addEventListener('abort', finish, { once: true });
      }

      scrollRail(direction) {
        const card = this.rail.querySelector('.tt-reviews__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        this.rail.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }

      revealCard(card) {
        if (!card) return;
        const cardRect = card.getBoundingClientRect();
        const railRect = this.rail.getBoundingClientRect();
        if (cardRect.left < railRect.left + 6 || cardRect.right > railRect.right - 6) {
          this.rail.scrollTo({ left: this.rail.scrollLeft + cardRect.left - railRect.left - 6, behavior: 'instant' });
        }
      }

      openDialog(opener) {
        if (this.dialog.open) return;
        this.opener = opener;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.dialog.showModal();
      }

      unlockScroll() {
        if (!this.scrollLocked) return;
        document.body.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }

      showCatalog() {
        this.embed.replaceChildren();
        this.activeIndex = -1;
        this.player.hidden = true;
        this.catalog.hidden = false;
        this.dialog.classList.remove('tt-reviews__dialog--playing');
        this.dialog.setAttribute('aria-labelledby', this.catalogHeading.id);
      }

      play(index) {
        const record = this.records[index];
        if (!record || !/^[\w-]{11}$/.test(record.id)) return;
        this.activeIndex = index;
        this.catalog.hidden = true;
        this.player.hidden = false;
        this.dialog.classList.add('tt-reviews__dialog--playing');
        this.dialog.setAttribute('aria-labelledby', this.playerTitle.id);
        this.updatePlayer(record);
        this.querySelector('[data-player-previous]').disabled = index === 0;
        this.querySelector('[data-player-next]').disabled = index === this.records.length - 1;
        const url = new URL('https://www.youtube-nocookie.com/embed/' + record.id);
        url.search = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0' }).toString();
        const start = this.startTime(record.url);
        if (start) url.searchParams.set('start', String(start));
        const iframe = document.createElement('iframe');
        iframe.src = url.href;
        iframe.title = this.playerTitle.textContent;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.embed.replaceChildren(iframe);
        this.loadMetadata(record);
      }

      startTime(rawUrl) {
        try {
          const params = new URL(rawUrl).searchParams;
          const value = params.get('start') || params.get('t') || '';
          if (/^\d+$/.test(value)) return Number(value);
          const parts = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(value);
          return parts ? Number(parts[1] || 0) * 3600 + Number(parts[2] || 0) * 60 + Number(parts[3] || 0) : 0;
        } catch { return 0; }
      }

      updatePlayer(record) {
        this.querySelector('[data-player-model]').textContent = record.model;
        this.playerTitle.textContent = record.title || record.card.querySelector('[data-video-title]').textContent;
        this.querySelector('[data-player-author]').textContent = record.author;
        const iframe = this.embed.querySelector('iframe');
        if (iframe) iframe.title = this.playerTitle.textContent;
      }

      async loadMetadata(record) {
        if (record.requested || (record.title && record.author)) return;
        record.requested = true;
        const signal = this.controller.signal;
        const key = 'tt-review-youtube-v1:' + record.id;
        let metadata;
        try {
          const cached = JSON.parse(localStorage.getItem(key) || 'null');
          if (cached && cached.expires > Date.now() && typeof cached.title === 'string' && cached.title.trim()) metadata = cached;
        } catch { /* Storage is optional. */ }
        if (!metadata) {
          const request = new AbortController();
          const abort = () => request.abort();
          signal.addEventListener('abort', abort, { once: true });
          const timeout = setTimeout(abort, 8000);
          try {
            const endpoint = new URL('https://www.youtube.com/oembed');
            endpoint.search = new URLSearchParams({ url: 'https://www.youtube.com/watch?v=' + record.id, format: 'json' }).toString();
            const response = await fetch(endpoint, { signal: request.signal, credentials: 'omit' });
            if (!response.ok) throw new Error('Unavailable video metadata');
            const data = await response.json();
            if (typeof data.title !== 'string' || !data.title.trim()) throw new Error('Missing video title');
            metadata = {
              title: data.title.slice(0, 512),
              author: typeof data.author_name === 'string' ? data.author_name.slice(0, 200) : '',
              expires: Date.now() + 86400000
            };
            try { localStorage.setItem(key, JSON.stringify(metadata)); } catch { /* Storage is optional. */ }
          } catch {
            if (!signal.aborted && !record.title) this.updateCards(record, this.dataset.unavailable);
          } finally {
            clearTimeout(timeout);
            signal.removeEventListener('abort', abort);
          }
        }
        if (!metadata || signal.aborted) return;
        const display = this.titleTranslations[record.id];
        if (!record.title) record.title = display && metadata.title === display.source ? display.title : metadata.title;
        if (!record.author) record.author = typeof metadata.author === 'string' ? metadata.author : '';
        if (display && record.author === display.author_original) record.author = display.author;
        this.updateCards(record, record.title);
      }

      updateCards(record, title) {
        this.querySelectorAll('[data-video-key="' + CSS.escape(record.key) + '"]').forEach(card => {
          card.querySelector('[data-video-title]').textContent = title;
          card.querySelector('[data-video-author]').textContent = record.author;
        });
        if (this.records[this.activeIndex] === record) this.updatePlayer(record);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
